/**
 * Helpers for values embedded in raw PostgREST filter strings.
 *
 * Most filters go through the supabase-js builder, which escapes for us. A few
 * paths have to hand-build the string form instead, because PostgREST's `or=()`
 * and `and=()` trees have no builder equivalent. Those strings are comma
 * separated, so an unescaped value containing a comma silently splits the tree:
 *
 *   full_text_search.plfts.LION PAINTING, INC
 *
 * PostgREST reads that as two conditions and rejects it with
 * "failed to parse logic tree". Searching for any business name containing a
 * comma failed this way (REG-685).
 */

/**
 * Quote a value for use inside a raw PostgREST filter string.
 *
 * PostgREST treats `,` `(` `)` and `"` as structural inside a logic tree. A
 * double-quoted value may contain them, with `\` and `"` backslash-escaped.
 * Values without those characters are left bare so ordinary filters keep their
 * existing, readable form.
 */
export function postgrestValue(value: unknown): string {
  const raw = String(value);
  if (/[,()"\\]/.test(raw)) {
    return `"${raw.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}"`;
  }
  return raw;
}
